<div class="admissions-commitments-view-part">
	<commitments-grid [service]="pageService" [rows]="commitments()"></commitments-grid>
</div>